import { currentPage } from './current-page/state';

let latestRenderWasOnTheServer = !__BROWSER__ || window?.IS_SERVER_SIDE_RENDERED;

let bindEventListener = false;
export function latestPageRenderWasOnTheServer() {
  if (__BROWSER__ && !bindEventListener) {
    const unsubscribe = currentPage.on(() => {
      latestRenderWasOnTheServer = false;
      unsubscribe();
    });

    bindEventListener = true;
  }

  return latestRenderWasOnTheServer;
}
